import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Stack,
  Link,
} from '@mui/material';
import {
  LinkedIn,
  Email,
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.900',
        color: 'white',
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              Actuation GmbH
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
              <Link component={RouterLink} to="/about" color="inherit" underline="hover" sx={{ opacity: 0.7, fontSize: '0.875rem' }}>
                About
              </Link>
              <Link component={RouterLink} to="/privacy-policy" color="inherit" underline="hover" sx={{ opacity: 0.7, fontSize: '0.875rem' }}>
                Privacy Policy
              </Link>
              <Link component={RouterLink} to="/terms-of-use" color="inherit" underline="hover" sx={{ opacity: 0.7, fontSize: '0.875rem' }}>
                Terms of Use
              </Link>
            </Stack>
            <Typography variant="body2" sx={{ opacity: 0.7, fontStyle: 'italic' }}>
              Actuation: The fact of making a machine start to work or a process start to happen.
            </Typography>
            <Box sx={{ mt: 2, opacity: 0.7 }}>
              <Typography variant="body2">Heinrichstrasse 118, 8005 Zürich</Typography>
              <Typography variant="body2">UID: CHE-260.133.410</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Stack direction="row" spacing={1} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
              <IconButton
                component="a"
                href="https://www.linkedin.com/company/actuation-gmbh"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                aria-label="LinkedIn"
                sx={{ '&:hover': { color: 'primary.light' } }}
              >
                <LinkedIn />
              </IconButton>
              <IconButton
                component="a"
                href="mailto:kevin.chen@actuation.ch"
                color="inherit"
                aria-label="Email"
                sx={{ '&:hover': { color: 'primary.light' } }}
              >
                <Email />
              </IconButton>
            </Stack>
            <Typography variant="body2" sx={{ mt: 2, opacity: 0.7 }}>
              © {new Date().getFullYear()} Actuation GmbH. All rights reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;

